module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--7--create-3f57191b.jpg";